import { handleClickColor } from "../../Common/Util";

export function BirthTimeRulingPlanet ({clientData}) {

  return(
    <table class="m-0 p-0 table table-bordered table-hover caption-top text-start">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Birth Time Ruling Planets</h4></caption>
      <thead class="m-0 p-0">
        <tr class="m-0 p-0">
          <th class="m-0 p-1 text-center">Planet</th> 
          <th class="m-0 p-1 text-center">Sign Lord</th> 
          <th class="m-0 p-1 text-center">Star Lord</th> 
          <th class="m-0 p-1 text-center">Sub Lord</th> 
          <th class="m-0 p-1 text-center">Sub Sub Lord</th> 
          <th class="m-0 p-1 text-center">SSS Lord</th> 
        </tr>
      </thead>
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Lagna</th>
          <td class="m-0 p-1 bg-transparent">{clientData.cuspalSignLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.cuspalStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.cuspalSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.cuspalSubSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.cuspalSubSubSubStarLord}</td>
        </tr>  
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Moon</th>
          <td class="m-0 p-1 bg-transparent">{clientData.signLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.starLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.subStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.subSubStarLord}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.subSubSubStarLord}</td>
        </tr>  
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent">Day Lord</th>
          <td class="m-0 p-1 bg-transparent" colSpan="5">{clientData.dayLord}</td>
        </tr>  
      </tbody>  
    </table>
  );
}